import { message, Dropdown, Avatar } from 'antd';
import { useState, useEffect } from 'react';
import { DownOutlined, UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import './UserNav.scss';

function UserNav() {
  const [welcomeText, setWelcomeText] = useState('Welcome');
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.username) {
      setWelcomeText(`Welcome, ${user.firstName}`);
    }
  }, [user]);

  const handleLogoutClick = async () =>
    // event: React.MouseEvent<HTMLElement>
    {
      // event.preventDefault();
      // event.stopPropagation();

      try {
        await logout();
        navigate('/sign-in');
      } catch (err) {
        console.error('Error logging out', err);
        message.error('There was an error logging out!');
      }
    };

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'user-header',
            label: (
              <div className="user-dropdown-header">
                <Avatar size={32} icon={<UserOutlined />} style={{ backgroundColor: '#233867' }} />
                <div className="user-dropdown-info">
                  <span className="user-dropdown-name">
                    {user?.firstName} {user?.lastName}
                  </span>
                  <span className="user-dropdown-username">@{user?.username}</span>
                </div>
              </div>
            ),
            disabled: true,
          },
          {
            type: 'divider',
          },
          {
            key: 'profile',
            label: 'View Profile',
            icon: <UserOutlined />,
            onClick: () => navigate('/user/profile?tab=profile'),
          },
          {
            key: 'settings',
            label: 'Account Settings',
            icon: <SettingOutlined />,
            onClick: () => navigate('/user/profile?tab=settings'),
          },
          {
            type: 'divider',
          },
          {
            key: 'logout',
            label: 'Logout',
            icon: <LogoutOutlined />,
            onClick: () => handleLogoutClick(),
            danger: true,
          },
        ],
      }}
    >
      <span
        style={{ fontSize: '12px', margin: '0 12px', cursor: 'pointer' }}
        data-test="welcome-text-user"
      >
        {welcomeText} <DownOutlined style={{ fontSize: '10px' }} />
      </span>
    </Dropdown>
  );
}

export default UserNav;
